var render = function render(_c,_vm){return _c('svg',_vm._g(_vm._b({staticClass:"icon check",class:[_vm.data.class, _vm.data.staticClass],attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}},'svg',_vm.data.attrs,false),_vm.listeners),[_c('path',{attrs:{"d":"M4.707 12.293a1 1 0 1 0-1.414 1.414l5 5a1 1 0 0 0 1.414 0l11-11a1 1 0 1 0-1.414-1.414L9 16.586z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }